import { gql } from '@apollo/client';

export const REMOVE_ACTIVITY_FROM_TEAM_MEMBER = gql`
  mutation removeActivityFromTeamMember($input: AddActivityToUserInput!) {
    user: removeActivityFromTeamMember(input: $input) {
      id
    }
  }
`;
